module.exports = __webpack_public_path__ + "static/media/toastError.d848d9ea.svg";